





































































































































































































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Confidential extends QuizPage {
  private created() {
    this.init("confidential", "/region");
  }
  private goNextOverride() {
    if (this.$store.state.personalSelection.includes("none") && this.selected.includes("none")) {
      this.nextPage = "/nota";
    }
    this.goNext();
  }
}
